import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button, Space, message, Form } from 'antd';
import { ArrowRightOutlined, NotificationOutlined } from '@ant-design/icons';
import MainLayout from '../../layouts/MainLayout';
import { noticesApi, show422Error, ValidationError } from '../../utils/api';
import { FormSkeleton } from '../../components/SkeletonLoaders';
import NoticeForm from '../../components/notices/NoticeForm';
import { PANEL_PRIMARY_BTN_CLASS } from '../../constants/ui';

const AddNotice = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await noticesApi.getCreateData();
        const data = res?.data ?? res;
        setTeams(data?.teams || []);
        setEmployees(data?.employees || []);
        setClients(data?.clients || []);
        form.setFieldsValue({ to: 'employee' });
      } catch (e) {
        message.error(e?.message || 'خطا در دریافت اطلاعات فرم');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [form]);

  const handleSubmit = async (payload) => {
    setSubmitting(true);
    try {
      await noticesApi.create(payload);
      message.success('اعلان ثبت شد');
      navigate('/notices');
    } catch (e) {
      if (e instanceof ValidationError || e?.error?.details) show422Error(e, form);
      else message.error(e?.message || 'خطا در ثبت اعلان');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MainLayout>
      <div className="custom-font" style={{ fontFamily: 'CustomFont' }}>
        <Card className="shadow-xl border-0" bodyStyle={{ padding: 0 }}>
          <div className="flex items-center justify-between flex-wrap gap-4 p-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 dark:bg-indigo-900/20 flex items-center justify-center">
                <NotificationOutlined className="text-indigo-600 dark:text-indigo-400 text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 m-0">اعلان جدید</h1>
              </div>
            </div>
            <Space>
              <Button icon={<ArrowRightOutlined />} onClick={() => navigate('/notices')}>
                بازگشت
              </Button>
              <Button type="primary" icon={<NotificationOutlined />} disabled className={PANEL_PRIMARY_BTN_CLASS}>
                راهنما
              </Button>
            </Space>
          </div>

          <div className="p-6 bg-gray-50 dark:bg-gray-900/50 rounded-b-xl">
            {loading ? (
              <FormSkeleton />
            ) : (
              <Card className="shadow-sm border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 custom-font">
                <NoticeForm
                  form={form}
                  submitting={submitting}
                  teams={teams}
                  employees={employees}
                  clients={clients}
                  onSubmit={handleSubmit}
                  onCancel={() => navigate('/notices')}
                />
              </Card>
            )}
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default AddNotice;
